import Image from '@eliadmin/core/src/components/image/image-wrapped';

import { cn } from '@eliadmin/core/src/utils/style-utils';

interface ImageCompProps {
  imageUrl: string;
  alt: string;
  className?: {
    container?: string;
    image?: string;
  };
  priority?: boolean;
  loading?: 'eager' | 'lazy';
}

export function ImageComp({
  imageUrl,
  alt,
  className,
  priority = false,
  loading = 'lazy',
}: ImageCompProps) {
  return (
    <div className={cn('relative w-full max-w-[587px]', className?.container)}>
      <Image
        src={imageUrl}
        alt={alt}
        width={0}
        height={0}
        className={cn(
          'relative z-10 w-full max-w-[587px] object-cover object-center',
          className?.image,
        )}
        sizes="(max-width: 768px) 100vw, (max-width: 1200px) 50vw, 33vw"
        priority={priority}
        loading={loading}
      />
      <Image
        src={'/images/primary-stripe.svg'}
        alt={alt}
        width={0}
        height={0}
        className="absolute -bottom-6 left-1/2 z-0 h-auto w-full -translate-x-1/2 px-4"
      />
    </div>
  );
}
